import { useMutation } from 'react-query';
import axios from 'axios';
import * as UI from 'Shared/UI';

export const enable = async (identifier) => {
  try {
    const { data } = await axios.post(
      `/organizations/api/${identifier}/player_insights/enable`
    );
    return data;
  } catch (err) {
    throw err;
  }
};

export const useEnablePlayerInsights = () => {
  return useMutation(enable, {
    onError: (err) => {
      UI.showPageNotice(err, 'error');
    },
  });
};
